import { cn } from '@/lib/cn';
import { History, Trash2 } from 'lucide-react';

import type { JSX } from "react";

interface TemplatePreviewThumbnailProps {
  variant?: 'preview' | 'deleted' | 'reverted';
  className?: string;
}

/**
 * TemplatePreviewThumbnail. Decorative mock of template content used by the
 * Ask Heidi template tool cards. Pure visual filler. Not a real preview of
 * the affected template.
 */
export const TemplatePreviewThumbnail = ({
  variant = 'preview',
  className,
}: TemplatePreviewThumbnailProps): JSX.Element => {
  if (variant === 'deleted' || variant === 'reverted') {
    const Icon = variant === 'deleted' ? Trash2 : History;
    return (
      <div
        aria-hidden="true"
        className={cn(
          'relative h-[105px] w-[104px] shrink-0 rounded-xs bg-surface-elevated shadow-sm',
          className
        )}
      >
        <Icon className="absolute start-1/2 top-[40px] size-7 -translate-x-1/2 -translate-y-1/2 text-text-disabled/40" />
      </div>
    );
  }

  return (
    <div
      aria-hidden="true"
      className={cn(
        'flex h-[105px] w-[104px] shrink-0 flex-col gap-1.5 rounded-xs bg-surface-elevated p-1.5 shadow-sm',
        className
      )}
    >
      <div className="flex flex-col gap-1">
        <div className="h-1.5 w-8/12 rounded-full bg-text-disabled" />
        <div className="h-1.5 w-10/12 rounded-full bg-text-disabled/50" />
        <div className="h-1.5 w-full rounded-full bg-text-disabled/50" />
      </div>
      <div className="flex flex-col gap-1">
        <div className="h-1.5 w-full rounded-full bg-text-disabled" />
        <div className="h-1.5 w-7/12 rounded-full bg-text-disabled/50" />
        <div className="h-1.5 w-9/12 rounded-full bg-text-disabled/50" />
      </div>
    </div>
  );
};
